/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerAnnouncement } from '../../models/banner-announcement';
import { FeatureAnnouncement } from '../../models/feature-announcement';
import { HeadlineAnnouncement } from '../../models/headline-announcement';
import { ImportantDatesAnnouncement } from '../../models/important-dates-announcement';

export interface CreateAnnouncement$Params {
      body: (BannerAnnouncement | FeatureAnnouncement | HeadlineAnnouncement | ImportantDatesAnnouncement)
}

export function createAnnouncement(http: HttpClient, rootUrl: string, params: CreateAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, createAnnouncement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

createAnnouncement.PATH = '/announcements';
